import React from 'react';
import PropTypes from 'prop-types';
import LoginModalHoc from 'core/hoc/LoginModalHoc';
import { FavoriteButton } from 'listing/components';
import { ListingProvider } from 'core/providers/ListingApp';
import { Row } from './styles';

const Buttons = ({ listingProvider, favoriteButton, onWishlistSuccess }) => (
	<ListingProvider value={listingProvider}>
		<LoginModalHoc contextUsage="like-wish-login">
			{({ triggerLoginModal }) =>
				<Row>
					<FavoriteButton
						{...favoriteButton}
						triggerLogin={triggerLoginModal}
						onSuccess={onWishlistSuccess}
					/>
				</Row>
			}
		</LoginModalHoc>
	</ListingProvider>
);

Buttons.propTypes = {
	listingProvider: PropTypes.shape({
		likes: PropTypes.number,
		hasFavorited: PropTypes.bool,
	}),
	favoriteButton: PropTypes.shape({
		listingId: PropTypes.number.isRequired,
		customerId: PropTypes.number,
	}),
	onWishlistSuccess: PropTypes.func,
};

Buttons.defaultProps = {};

export default Buttons;
